export const HISTORY_PERMISSIONS_MAP = {
    chemical: 'chemical',
    discovery: 'discovery',
    analytics: 'pro',
    cas: 'cas',
};
